import type { IconSvgObject } from './types';

const EquipmentBenchPressIcon: IconSvgObject = [
  ["path", { d: "M17.5 3V8M6.5 3V8M20 4V5.5M20 5.5V7M20 5.5H21.5M4 4V5.5M4 5.5V7M4 5.5H2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 5.5H6.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 5.5V9.5M14 5.5V9.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 16L7.92118 10.9923C8.2796 10.3778 8.93741 10 9.64874 10H14.3513C15.0626 10 15.7204 10.3778 16.0788 10.9923L19 16M5 16H19M5 16V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V16", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M16 19V21M8 19V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default EquipmentBenchPressIcon;
